var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"col-12 col-md-8 col-lg-6 pt-5 px-3 p_b__3"},[_c('h4',{staticClass:"mb-4"},[_vm._v(" Support ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }